import { render, staticRenderFns } from "./adminClientContentBoard.vue?vue&type=template&id=3ecd6627&scoped=true&"
import script from "./adminClientContentBoard.vue?vue&type=script&lang=js&"
export * from "./adminClientContentBoard.vue?vue&type=script&lang=js&"
import style0 from "./adminClientContentBoard.vue?vue&type=style&index=0&id=3ecd6627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd6627",
  null
  
)

export default component.exports